module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabItem",
    class: {
      active: _vm.itemData.value == _vm.value
    },
    on: {
      "click": function($event) {
        return _vm.$emit('select', _vm.itemData.value)
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.itemData.title) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8957823a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabTitle/tabItem.vue
// module id = 1568
// module chunks = 18